/* eslint-disable react/jsx-key */
import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import GlobalContext from "../../context/GlobalContext";
import BasicCard from "../common/BasicCard";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import { LazyLoadImage } from "react-lazy-load-image-component";
import bgImg from "../../assets/micasabackground.jpg";
import BannerRenderer from "../common/BannerRenderer";


const Categories = (props) => {
  const context = useContext(GlobalContext);
  const { restaurantId, type } = useParams();
  const items = context.menu[type].categories;

  const getBackgroundStyle = () => {
    let style = {};
    // if(context.configuration.restaurantDetails.parallaxUploaded !== "" && context.configuration.restaurantDetails.parallaxUploaded.startsWith("http")){
    //   console.log("vlagaa")
    //   style.backgroundImage = `url(${context.configuration.restaurantDetails.parallaxUploaded})`;
    //   /* Set a specific height */
    //   style.minHeight= "100%";
    //   /* Create the parallax scrolling effect */
    //   style.backgroundAttachment= "fixed";
    //   style.backgroundPosition= "center";
    //   style.backgroundRepeat= "no-repeat";
    //   style.backgroundSize= "cover";
    // }

    return style;
  };

  useEffect(() => {
    //window.scrollTo(0, 0)
    //console.log("brane")
    //window.scrollTo({top: 0, behavior: 'smooth'});
    document.documentElement.scrollTo(0, 0);
    //document.querySelector('body').scrollTo(0,0);
  }, []);

  const renderItems = (table) => {
    console.log("renderItems b",table);
    return items.map((item) => (
      <LazyLoadComponent>
        <BasicCard
          to={{
            pathname:
              "/" +
              restaurantId +
              "/categories/" +
              type +
              "/" +
              item.categoryId + 
              table,
            state: item,
          }}
          image={
            (item.image !== "null" && item.image) ||
            (item.items !== undefined &&
              item.items[0] !== undefined &&
              item.items[0].image)
          }
          title={item.name}
        />
      </LazyLoadComponent>
    ));
  };

  return (
    
        <div className="scroll-content" style={getBackgroundStyle()}>
          {renderItems(context?.configuration?.table)}
      {context.banner && <BannerRenderer image={context.configuration?.restaurantDetails?.banner}  link={context.configuration?.restaurantDetails?.bannerLink} linkEnabled={context.configuration?.restaurantDetails?.bannerLinkEnabled} />}

        </div>
    
  );
};

export default Categories;
